import { useEffect, useCallback } from 'react';
import { Modal } from '@simplywallst/ui-core';
import AnalystsTable from '@/pages/CompanyReport/components/AnalystsModal/components/AnalystsTable';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { getSummary, getAnalysts } from '@/pages/CompanyReport/redux/selectors';
import { getBrokersMap, getAnalystMap } from '@ducks/analysts/selectors';
import { fetchCompanyAnalysts } from '@/pages/CompanyReport/redux/routines';
import { useTracking } from 'react-tracking';

export interface AnalystsModalProps {
  companyId: string;
  closeModal: () => void;
  companyName?: string;
  analystCount?: number;
}

const AnalystsModal = ({
  companyId,
  closeModal,
  companyName,
  analystCount,
}: AnalystsModalProps) => {
  const { trackEvent, Track } = useTracking({
    type: 'track',
    subject: 'AnalystsModal',
  });
  const { summary, analyst, analystsMap, brokersMap } = useSelector(
    (state: any) => {
      const summary = getSummary(state, { companyId });
      const analysts = getAnalysts(state, { companyId });
      const brokersMap = getBrokersMap(state);
      const analystsMap = getAnalystMap(state);
      return {
        summary,
        analyst: analysts.analyst,
        brokersMap,
        analystsMap,
        isLoading: state.ui.analystsFetchStatus === 'fetching',
      };
    },
    shallowEqual
  );

  const handleClose = useCallback(() => {
    closeModal();
    trackEvent({
      action: 'click',
      modifier: 'close',
      subject: 'AnalystsModal',
    });
  }, [closeModal]);

  const dispatch = useDispatch();
  useEffect(() => {
    // cdm
    if (analyst.length === 0) {
      dispatch(fetchCompanyAnalysts.trigger({ companyId }));
    }
  }, [analyst.length, companyId, dispatch]);
  return (
    <Track>
      <Modal
        isServer={RUNTIME_ENV === 'server'}
        title="Analyst Sources"
        fullscreen={true}
        primaryLabel="Close"
        onSecondaryClick={handleClose}
        onPrimaryClick={handleClose}
      >
        <AnalystsTable
          companyId={companyId}
          companyName={companyName ?? summary.shortName}
          analystCount={analystCount ?? summary.analystCount}
          analystKeys={analyst}
          analystEntities={analystsMap}
          brokerEntities={brokersMap}
        />
      </Modal>
    </Track>
  );
};

export default AnalystsModal;
